<template>
  <div class="education p-4">
    <div class="flex flex-initial">
      <h3 class="text-2xl mb-6 border-b-2 border-solid border-gray-400 text-gray-600 font-light mb-1">
        Education</h3>
    </div>

    <div class="text text-black">

      <div class="flex flex-wrap overflow-hidden">

        <!--                  <div class="w-1/2 overflow-hidden">-->
        <div class="w-4/12 overflow-hidden">
          <!-- Column Content -->
          2015 - 2019 (not finished yet)
        </div>

        <!--                  <div class="w-1/2 overflow-hidden">-->
        <div class="w-8/12 overflow-hidden">
          <!-- Column Content -->
          <strong>Bachelor's degree, Information Technology</strong>
          <div>
            <i>Seraj University</i>
          </div>
          <div>Became a member of University Academic Association of Computer Science</div>
        </div>

      </div>


    </div>
  </div>
</template>

<script>
export default {
  name: "Education",
  data() {
    return {
    }
  },
}
</script>

<style scoped lang="scss">

</style>
